export default __webpack_public_path__ + "static/media/logo-leavening.398ebe14.png";